<template>

  <div>

    <div class="bg-gray-text p-6">
      <template v-if="isLoggedIn">
        <p class="text-center text-gray-charcoal font-bold leading-snug">Welcome back, USKC Member! <button @click="logout()" class="font-normal underline hover:no-underline" type="button">Logout</button></p>
      </template>

      <template v-else>
        <p class="text-center text-gray-charcoal font-bold leading-snug">Are you a member? <button @click="showLoginForm = !showLoginForm" class="font-normal underline hover:no-underline" type="button">Login</button></p>
      </template>
    </div>

    <div v-if="showLoginForm" class="w-full bg-white px-6 py-4 border-b border-gray-text">

      <p class="hdg-4 mb-8">Welcome back, USKC Member!</p>

      <div class="buy-membership__input" :class="{ 'has-error': loginError }">
        <label for="checkout_membership_id_login">Membership ID</label>
        <p v-if="loginError" class="text-sm mb-2 text-red-error">Invalid Membership ID/Zip Code.</p>
        <div class="relative">
          <input v-model="membershipId" type="text" class="w-full text-gray-charcoal bg-gray-light-gray px-6 h-16 rounded-sm" name="checkout_membership_id_login" id="checkout_membership_id_login" value="">
        </div>
      </div>

      <div class="buy-membership__input" :class="{ 'has-error': loginError }">
        <label for="checkout_zip_code_login">Zip Code</label>
        <div class="relative">
          <input v-model="zipCode" type="text" class="w-full text-gray-charcoal bg-gray-light-gray px-6 h-16 rounded-sm" name="checkout_zip_code_login" id="checkout_zip_code_login" value="">
        </div>
      </div>

      <div class="flex mt-12">
        <button class="flex-initial ml-auto btn-tan" type="button" @click="login()">Log In</button>
      </div>

    </div>

  </div>

</template>

<script>
export default {
  props: [ 'data', 'image' ],
  data() {
    return {
      showLoginForm: false,
      isRunningLogin: false,
      membershipId: '',
      zipCode: '',
      loginError: false,
    };
  },
  mounted() {
  },
  methods: {
    login: function() {
      const _this = this;
      _this.loginError = false;

      if ( ! _this.isRunningLogin ) {
        _this.isRunningLogin = true;
        $.post(
            site_info.ajax_url,
            {
              action: 'll_run_function',
              function: 'login_to_ticketure',
              params: {
                member_number: _this.membershipId,
                zip_code: _this.zipCode,
              },
            },
            function( data, textStatus, xhr ) {
              data = $.parseJSON( data );
              if ( data.status === 'success' ) {
                _this.isRunningLogin = false;

                if ( data.response ) {
                  _this.$store.commit( 'setLoginState', true );
                  _this.showLoginForm = false;
                } else {
                  _this.loginError = true;
                }
              }
            }
        );
      }
    },
    logout: function() {
      const _this = this;

      $.post(
          site_info.ajax_url,
          {
            action: 'll_run_function',
            function: 'logout_of_ticketure',
            params: {
              run: true,
            },
          },
          function( data, textStatus, xhr ) {
            data = $.parseJSON( data );
            if ( data.status === 'success' ) {
              app.components['cart'].loadCart();
              _this.$store.commit( 'setLoginState', false );
            }
          }
      );
    },
  },
  watch: {
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.state.isLoggedIn;
    }
  },
};
</script>
